import React, { Component } from 'react';
import PropTypes from 'prop-types';
import List from 'react-list';

// This uses `react-list`, which is pretty lightweight. But we aren't currently taking
// much advantage of it, so you can easily remove it if necessary. This component is a
// wrapper that implements a trigger that is called when you reach the bottom of the page.
export default class InfiniteList extends Component {
  static propTypes = {
    length: PropTypes.number.isRequired,
    loadingMessage: PropTypes.string,
    noResultsMessage: PropTypes.string,
    loadingElement: PropTypes.element,
    noResultsElement: PropTypes.element,
    onLoad: PropTypes.func.isRequired,
    reachedEnd: PropTypes.bool,
    reachedEndMessage: PropTypes.any.isRequired,
    scrollListener: PropTypes.string,
    itemsRenderer: PropTypes.func,
    asTable: PropTypes.bool,
  };

  static defaultProps = {
    asTable: false,
    reachedEnd: false,
    scrollListener: null,
  };

  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  isNearBottom() {
    if (this.props.scrollListener === null) {
      return $(window).scrollTop() > $(document).height() - $(window).height() - 100;
    } else {
      return $(this.props.scrollListener).scrollTop() > $(this.props.scrollListener).children().height() - $(this.props.scrollListener).height() - 100;
    }
  }

  handleScroll = () => {
    if (this.props.reachedEnd) return;
    if (this.isNearBottom()) this.handleLoad();
  };

  handleLoad() {
    if (this.state.loading) return;
    this.setState({ loading: true });
    this.props.onLoad(() => this.setState({ loading: false }));
  }

  componentDidMount() {
    const element = this.props.scrollListener === null ? document : document.querySelector(this.props.scrollListener);
    element.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    const element = this.props.scrollListener === null ? document : document.querySelector(this.props.scrollListener);
    element.removeEventListener('scroll', this.handleScroll);
  }

  renderReachedEnd() {
    return (
      <div className="u-text-center u-infoText reached-end">
        <p className="u-mb-2" dangerouslySetInnerHTML={{ __html: this.props.reachedEndMessage }} />
      </div>
    );
  }

  renderLoading() {
    return this.props.loadingElement || (
      <div className="u-text-center loading u-infoText">
        <p className="u-mb-2" dangerouslySetInnerHTML={{ __html: this.props.loadingMessage }} />
      </div>
    );
  }

  renderNoResults() {
    return this.props.noResultsElement || (
      <div className="u-text-center u-infoText u-p-8">
        <div>{this.props.noResultsMessage}</div>
      </div>
    );
  }

  renderAsList() {
    if (!this.props.length && !this.state.loading) {
      return this.renderNoResults();
    }

    return (
      <div>
        <List {...this.props} scrollParentGetter={() => this.props.scrollListener !== null ? document.querySelector(this.props.scrollListener) : window} />
        {this.props.reachedEnd && this.renderReachedEnd()}
        {!this.props.reachedEnd && this.state.loading && this.renderLoading()}
      </div>
    );
  }

  renderAsTable() {
    if (!this.props.length && !this.state.loading) {
      return (
        <tbody>
          <tr>
            <td colSpan="999">
              {this.renderNoResults()}
            </td>
          </tr>
        </tbody>
      );
    }
    const itemsRenderer = (items, ref) => {
      return (
        <tbody ref={ref}>
          {items}
          {this.props.reachedEnd && <tr><td colSpan="999">{this.renderReachedEnd()}</td></tr>}
          {!this.props.reachedEnd && this.state.loading && <tr><td colSpan="999">{this.renderLoading()}</td></tr>}
        </tbody>
      );
    }
    return <List {...this.props} itemsRenderer={itemsRenderer} scrollParentGetter={() => this.props.scrollListener !== null ? document.querySelector(this.props.scrollListener) : window} />
  }

  render() {
    if (this.props.asTable) {
      return this.renderAsTable();
    }
    return this.renderAsList();
  }
}
